import { Route } from "react-router-dom";
import ProtectedRouteV2 from "../routes/ProtectedRouteV2";
import PageTitle from "../components/PageTitle";
import GeneralDashboard from "../pages/Dashboard/GeneralDashboard";
import SalesDashboard from "../pages/Dashboard/SalesDashboard";
import PurchasesDashboard from "../pages/Dashboard/PurchasesDashboard";
import ClientsDashboard from "../pages/Dashboard/ClientsDashboard";
import SuppliersDashboard from "../pages/Dashboard/SuppliersDashboard";
import InventoryDashboard from "../pages/Dashboard/InventoryDashboard";
import DashboardIndexRedirect from "../pages/Dashboard/DashboardIndexRedirect";

/**
 * 🧭 Rutas del Dashboard (protegidas con verificación de acceso backend)
 */
const dashboardRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    {/* 🔹 Redirección al Dashboard General */}
    <Route index element={<DashboardIndexRedirect />} />

    {/* 🔹 Dashboard General */}
    <Route
      path="/dashboard/general"
      element={
        <>
          <PageTitle title="Dashboard General" />
          <GeneralDashboard />
        </>
      }
    />

    {/* 🔹 Dashboards específicos */}
    <Route
      path="/dashboard/sales"
      element={
        <>
          <PageTitle title="Dashboard de Ventas" />
          <SalesDashboard />
        </>
      }
    />
    <Route
      path="/dashboard/purchases"
      element={
        <>
          <PageTitle title="Dashboard de Compras" />
          <PurchasesDashboard />
        </>
      }
    />
    <Route
      path="/dashboard/clients"
      element={
        <>
          <PageTitle title="Dashboard de Clientes" />
          <ClientsDashboard />
        </>
      }
    />
    <Route
      path="/dashboard/suppliers"
      element={
        <>
          <PageTitle title="Dashboard de Proveedores" />
          <SuppliersDashboard />
        </>
      }
    />
    <Route
      path="/dashboard/inventory"
      element={
        <>
          <PageTitle title="Dashboard de Inventario" />
          <InventoryDashboard />
        </>
      }
    />
  </Route>
);

export default dashboardRoutes;
